import React from "react";
import CourseDetailPage from "../components/Courses/Shared/CourseDetailPage";

const ComputerArchitecture = () => {
  const courseData = {
    backLink: "/course/computer-engineering",
    heroTitle: "Computer Architecture",
    heroSubtitle: "Understand the design and organization of computer hardware systems",
    heroImage: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    introParagraphs: [
      "Computer Architecture explores the fundamental design principles and organization of computer systems. This comprehensive course covers the internal structure of processors, memory systems, input/output mechanisms, and how these components work together to execute programs efficiently.",
      "You'll learn about instruction set architecture, processor design, memory hierarchy, caching, pipelining, and parallel processing. The course examines both classical and modern computer architectures, including RISC and CISC processors, multi-core systems, and emerging technologies.",
      "Through hands-on projects and simulations, you'll gain practical experience in designing and analyzing computer systems. This course provides the foundation for understanding how software interacts with hardware and prepares you for advanced topics in computer engineering and system design."
    ],
    learningOutcomes: [
      "Understand instruction set architecture and assembly language",
      "Master processor design and execution principles",
      "Learn memory hierarchy and caching strategies",
      "Understand pipelining and parallel processing techniques",
      "Analyze performance metrics and optimization strategies",
      "Design and simulate computer system components",
      "Understand input/output systems and interfaces",
      "Learn about modern processor architectures",
      "Apply computer architecture principles to real systems",
      "Prepare for advanced computer engineering courses"
    ],
    careerPaths: [
      {
        title: "Computer Architect",
        description: "Design and develop computer system architectures for various applications.",
        color: "bg-gradient-to-r from-blue-500 to-purple-600"
      },
      {
        title: "Processor Design Engineer",
        description: "Design and optimize microprocessors and CPU architectures.",
        color: "bg-gradient-to-r from-green-500 to-teal-600"
      },
      {
        title: "Systems Engineer",
        description: "Design and integrate computer systems for specific applications.",
        color: "bg-gradient-to-r from-orange-500 to-red-600"
      },
      {
        title: "Performance Engineer",
        description: "Analyze and optimize system performance for maximum efficiency.",
        color: "bg-gradient-to-r from-pink-500 to-rose-600"
      },
      {
        title: "Research Engineer",
        description: "Conduct research in computer architecture and emerging technologies.",
        color: "bg-gradient-to-r from-indigo-500 to-blue-600"
      },
      {
        title: "Technical Consultant",
        description: "Provide expertise in computer system design and optimization.",
        color: "bg-gradient-to-r from-purple-500 to-indigo-600"
      }
    ],
    prerequisites: "Digital Electronics and basic programming knowledge",
    duration: "16 weeks",
    level: "Intermediate to Advanced"
  };

  return <CourseDetailPage {...courseData} />;
};

export default ComputerArchitecture;

